/*!
 * bz-game-products.js — per-market checkout inputs for The Focus Challenge segue.
 *
 * GENERATED from config/brainzyme_product_matrix.json (the canonical SoT). Do NOT hand-edit: a
 * mistyped variant ID silently sells the wrong product at the wrong price.
 *
 * KEY NAMES MATTER. bz-game-segue.js reads { name, variantId, sellingPlanId, priceOnce, priceSub }.
 * The first version of this file emitted the matrix key names (product_name / price /
 * subscription_price), so name and BOTH prices rendered EMPTY — a product card asking people to buy
 * something it never named, at no stated price. Every automated gate passed; only looking at the
 * screenshot caught it.
 *
 *  is the trademarked SKU name and is identical in all markets: the front labels are English
 * by design (memory/feedback_english_only_front_labels.md). Prices are per-market DATA formatted to
 * local convention, never copy.
 *
 * FOCUS ORIGINAL is deliberately ABSENT - Calum ruled it is not routable from the preference
 * question ("original only for children or sensitive disposition").
 */
(function (root) {
  'use strict';
  root.BZGameProducts = {
    "uk": {
      "pro": {
        "name": "FOCUS PRO™",
        "variantId": "31430904086606",
        "sellingPlanId": "689576280347",
        "priceOnce": "£29.00",
        "priceSub": "£24.36",
        "storefrontBase": "https://brainzyme.myshopify.com"
      },
      "elite": {
        "name": "FOCUS ELITE™",
        "variantId": "31430974963790",
        "sellingPlanId": "689576280347",
        "priceOnce": "£47.00",
        "priceSub": "£39.48",
        "storefrontBase": "https://brainzyme.myshopify.com"
      },
      "bundle": {
        "name": "Starter Bundle",
        "variantId": "39642628849742",
        "sellingPlanId": "689576804635",
        "priceOnce": "£44.00",
        "priceSub": "£36.96",
        "storefrontBase": "https://brainzyme.myshopify.com"
      }
    },
    "de": {
      "pro": {
        "name": "FOCUS PRO™",
        "variantId": "30306895102042",
        "sellingPlanId": "688749478152",
        "priceOnce": "31,75 €",
        "priceSub": "26,67 €",
        "storefrontBase": "https://brainzyme-de.myshopify.com"
      },
      "elite": {
        "name": "FOCUS ELITE™",
        "variantId": "30306895265882",
        "sellingPlanId": "688749478152",
        "priceOnce": "52,00 €",
        "priceSub": "43,68 €",
        "storefrontBase": "https://brainzyme-de.myshopify.com"
      },
      "bundle": {
        "name": "Starter Bundle",
        "variantId": "42012267217045",
        "sellingPlanId": "688749871368",
        "priceOnce": "47,80 €",
        "priceSub": "40,15 €",
        "storefrontBase": "https://brainzyme-de.myshopify.com"
      }
    },
    "fr": {
      "pro": {
        "name": "FOCUS PRO™",
        "variantId": "28966088867945",
        "sellingPlanId": "688968663382",
        "priceOnce": "31,75 €",
        "priceSub": "26,67 €",
        "storefrontBase": "https://brainzyme-fr.myshopify.com"
      },
      "elite": {
        "name": "FOCUS ELITE™",
        "variantId": "28966093619305",
        "sellingPlanId": "688968663382",
        "priceOnce": "52,00 €",
        "priceSub": "43,68 €",
        "storefrontBase": "https://brainzyme-fr.myshopify.com"
      },
      "bundle": {
        "name": "Starter Bundle",
        "variantId": "39840224870505",
        "sellingPlanId": "688969056598",
        "priceOnce": "47,80 €",
        "priceSub": "40,15 €",
        "storefrontBase": "https://brainzyme-fr.myshopify.com"
      }
    },
    "us": {
      "pro": {
        "name": "FOCUS PRO™",
        "variantId": "39256090771648",
        "sellingPlanId": "1776615616",
        "priceOnce": "$40.00",
        "priceSub": "$33.60",
        "storefrontBase": "https://brainzyme-us.myshopify.com"
      },
      "elite": {
        "name": "FOCUS ELITE™",
        "variantId": "39257034883264",
        "sellingPlanId": "1776615616",
        "priceOnce": "$65.00",
        "priceSub": "$54.60",
        "storefrontBase": "https://brainzyme-us.myshopify.com"
      },
      "bundle": {
        "name": "Starter Bundle",
        "variantId": "41555300679872",
        "sellingPlanId": "1776353472",
        "priceOnce": "$60.00",
        "priceSub": "$50.40",
        "storefrontBase": "https://brainzyme-us.myshopify.com"
      }
    }
  };
})(window);
